import { type TableSelectedCell, useTableRows } from '@/components/custom/erp/input-table-v2';
import { calculateTaxAmount } from '../../../utils/tax-calc-util';

export interface TaxRow {
  uuid: string;
  line?: number;
  t_tien_nt?: number;
  t_thue_nt?: number;
  ma_thue_data?: {
    thue_suat?: number;
    [key: string]: MuaHangRecord;
  };
  [key: string]: MuaHangRecord;
}

export type SelectedCellInfo = TableSelectedCell;

export function useTaxRows(initialRows: TaxRow[] = []) {
  const getTaxUpdates = (row: TaxRow, field: string, value: MuaHangRecord): Partial<TaxRow> => {
    if (field === 't_tien_nt') {
      const taxRate = row.ma_thue_data?.thue_suat || 0;
      return {
        t_thue_nt: calculateTaxAmount(Number(value) || 0, taxRate)
      };
    }

    if (field === 'ma_thue_data') {
      const taxRate = value?.thue_suat || 0;
      return {
        t_thue_nt: calculateTaxAmount(row.t_tien_nt || 0, taxRate)
      };
    }

    return {};
  };

  const {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs
  } = useTableRows<TaxRow>({
    initialRows,
    defaultRows: 0,
    onFieldValueChange: (row, field, value) =>
      ({
        ...getTaxUpdates(row, field, value)
      }) as Partial<TaxRow>,
    defaultField: 'dien_giai'
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    handleCellValueChange,
    setNonWritableFields,
    setPasteConfigs
  };
}
